/** The three legs of the Results split, named once (round-4 G1-N3/G1-N4): what each is, in the words every screen and the formula line use. */
export const SPLIT_LEG = {
  price: { label: "Share price", gloss: "your share price, scaled to your twin's share count, less your twin's share price" },
  cash: { label: "Cash returned", gloss: "dividends, plus the share-count effect of buybacks, counted every year since the start" },
  lookThrough: { label: "Look-through revaluation", gloss: "the official score less the reported-only score (share price plus cash returned)" },
} as const;

/** What the score's dollars are read on. */
export const READS_ON = "per share held at the start, in today's dollars";
